import { render, staticRenderFns } from "./ModalCancelPesanan.vue?vue&type=template&id=16ba8974&"
import script from "./ModalCancelPesanan.vue?vue&type=script&lang=js&"
export * from "./ModalCancelPesanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports